<template>
    <div class="container-fluid carregando d-none">
        <div class="loading">

            <div class="loader"><img src="../../assets/pin_lliege.png" width="70" class="pulse"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Layout'
    }
</script>

<style scoped>
    .carregando{
        display: block;
        position: fixed;
        z-index: 9999;
    }
    .loading {
        position: fixed;
        top: 0; right: 0;
        bottom: 0; left: 0;
        background: #ffffff7a;
    }
    .loader {
        left: 50%;
        margin-left: -4em;
    }
    .loader, .loader:after {
        border-radius: 50%;
        width: 8em;
        height: 8em;
        display: block;
        position: absolute;
        top: 50%;
        margin-top: -4.05em;
    }
    .pulse {
        animation: pulse 0.7s infinite;
        margin: 0 auto;
        display: table;
        animation-direction: alternate;
        -webkit-animation-name: pulse;
        animation-name: pulse;
    }

    @-webkit-keyframes pulse {
    0% {
        -webkit-transform: scale(1);
        -webkit-filter: brightness(100%);
    }
    100% {
        -webkit-transform: scale(1.1);
        -webkit-filter: brightness(200%);
    }
    }

    @keyframes pulse {
    0% {
        transform: scale(1);
        filter: brightness(100%);
    }
    100% {
        transform: scale(1.1);
        filter: brightness(200%);
    }
    }
</style>
